export default __webpack_public_path__ + "static/media/chennai.c40ea34e.jpeg";